import { CLICK_DELAY } from '../const';

export function doubleClick(botTarget: HTMLDivElement, delay = CLICK_DELAY) {
  // Dispatching a double-click event didn't work, so we use a timeout to
  // simulate a double-click.
  botTarget.click();

  return setTimeout(() => botTarget.click(), delay);
}
